import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import type TaskPlannedJournalEvent from "parog-web/models/task-planned-journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class TaskProcessedJournalEvent extends JournalEvent {
  static override type = "task-processed-journal-event";

  @attr("string") declare actionTaken: string;

  @attr("boolean", {
    allowNull: true
  })
  declare processOlderTasks: boolean;

  @belongsTo("task-planned-journal-event", {
    async: false,
    inverse: "taskProcessedJournalEvent"
  })
  declare taskPlannedJournalEvent: TaskPlannedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      taskPlannedJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.task-processed-journal-event.task-planned-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.task-processed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "taskProcessedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "task-processed-journal-event": TaskProcessedJournalEvent;
  }
}
